/** Labelled value in an event detail grid (uppercase caption above the value). */
function DetailField({ label, value }) {
  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      <dt className="text-[11px] uppercase tracking-wide text-content-faint">{label}</dt>
      <dd className="break-words text-sm font-medium text-content">{value}</dd>
    </div>
  );
}

export default DetailField;
